import React from 'react'

const Headline = ({
  kicker,
  headline,
  headline_level = 'h2',
  tagName = 'h2',
  subheadline,
  className,
}) => {
  const HTag = tagName
  return (
    <>
      {(kicker || headline || subheadline) && (
        <div className={className}>
          {kicker && kicker.length > 0 && (
            <p className={`${headline_level}-kicker`}>{kicker}</p>
          )}

          {headline && headline.length > 0 && (
            <HTag className={`${headline_level}-headline`}>{headline}</HTag>
          )}
          {subheadline && subheadline.length > 0 && (
            <p className={`${headline_level}-subheadline`}>{subheadline}</p>
          )}
        </div>
      )}
    </>
  )
}

export default Headline
